import { Table } from '@tanstack/react-table';
import { XIcon } from 'lucide-react';
import { ComponentPropsWithoutRef, forwardRef, useMemo } from 'react';

import { Button } from 'src/components/ui/button';
import { cn } from 'src/lib/utils';

export type DataTableResetButtonProps<T = any> = ComponentPropsWithoutRef<'button'> & {
  table: Table<T>;
  excludes?: string[]; // 要排除重置的列字段名数组
  onReset?: () => void;
};

export const DataTableResetButton = forwardRef<HTMLButtonElement, DataTableResetButtonProps>(
  ({ table, excludes = [], className, children, onReset, onClick, ...props }, ref) => {
    const columnFilters = table.getState().columnFilters;
    const globalFilter = table.getState().globalFilter;
    const isFiltered = useMemo(() => {
      return (
        columnFilters.filter((filter) => !excludes.includes(filter.id)).length > 0 || !!globalFilter
      );
    }, [columnFilters, excludes, globalFilter]);

    const handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
      const currentFilters = table.getState().columnFilters;
      const filtersToKeep = currentFilters.filter((filter) => excludes.includes(filter.id));
      table.setColumnFilters(filtersToKeep);
      onReset?.();
      onClick?.(e);
    };

    if (!isFiltered) return null;

    return (
      <Button
        ref={ref}
        variant="ghost"
        onClick={handleReset}
        className={cn('hidden h-8 px-2 xl:px-3 xl:flex', className)}
        {...props}
      >
        {children ?? (
          <>
            重置
            <XIcon className="h-4 w-4" />
          </>
        )}
      </Button>
    );
  }
);

DataTableResetButton.displayName = 'DataTableResetButton';
